var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 512,
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    stroke: "#fff",
    fill: "#fff",
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.75 12c0-5.933-4.817-10.75-10.75-10.75s-10.75 4.817-10.75 10.75 4.817 10.75 10.75 10.75c.414 0 .75-.336.75-.75s-.336-.75-.75-.75c-5.105 0-9.25-4.145-9.25-9.25s4.145-9.25 9.25-9.25 9.25 4.145 9.25 9.25c0 .414.336.75.75.75s.75-.336.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.75 6.5v4.689s-3.78 3.781-3.78 3.781c-.293.292-.293.768 0 1.06.292.293.768.293 1.06 0l4-4c.141-.14.22-.331.22-.53v-5c0-.414-.336-.75-.75-.75s-.75.336-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.915 14.389-3.029 4.327c-.093.133-.141.292-.136.454l.094 2.854c.007.236.126.455.319.59.193.136.439.172.664.099l2.713-.889c.155-.05.288-.149.381-.282l3.03-4.327c.554-.792.362-1.883-.43-2.438l-1.168-.818c-.792-.554-1.883-.362-2.438.43zm1.229.86c.079-.113.235-.14.348-.061 0 0 1.169.818 1.169.818.113.079.14.235.061.348 0 0-2.886 4.122-2.886 4.122s-1.526.5-1.526.5-.052-1.605-.052-1.605z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/edit-button.323898cd.svg";
export { ForwardRef as ReactComponent };